export default function getListOfRepliesStatus(commentsChildren) {
  const repliesDeletedStatusList = [];
  const repliesDeletedStatus = commentsChildren && commentsChildren.map((commentsChild) => {
    repliesDeletedStatusList.push(commentsChild.deleted);

    return repliesDeletedStatusList.every((reply) => reply);
  });

  return repliesDeletedStatus && repliesDeletedStatus.every((reply) => reply);
}
